import { getCurrentInstance } from 'vue'

export function usePlugin () {
  const { proxy } = getCurrentInstance()
  const $confirm = proxy.$confirm
  const $toast = proxy.$toast

  return {
    $confirm,
    $toast
  }
}
